import { motion } from 'framer-motion';

const GenericButton = ({ icon: Icon, iconClassName="w-5 h-5", children, responsive=false, loading=false, appendClassName="", type="button", ...props }) => {
  return (
    <motion.button
      type={type}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`flex items-center ${responsive ? "xl:space-x-2" : "space-x-2"} px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600`.concat(` ${appendClassName}`)}
      {...props}
    >
      <>
        {Icon ? 
          (loading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : <Icon className={`${iconClassName} flex-none`} />)
          : 
            (loading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div> : null)              
        }
        {children && <span className={responsive ? "hidden xl:block" : ""}>{children}</span>}
      </>
    </motion.button>
  );
};

export default GenericButton;